import { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';

import { AspectRatio } from '../../types.ts/video';
import { forIPad } from '../../utility/styled';

import type { ReactNode } from 'react';

function BottomItems({
  aspectRatio,
  timelineHeight,
  children,
}: {
  aspectRatio?: AspectRatio;
  timelineHeight: number;
  children: ReactNode;
}) {
  const bottomItemsRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!bottomItemsRef.current) return;
    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        setWidth(entry.contentRect.width);
      }
    });
    observer.observe(bottomItemsRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <Wrapper
      ref={bottomItemsRef}
      aspectRatio={aspectRatio}
      timelineHeight={timelineHeight}
      currentWidth={width}
    >
      {children}
    </Wrapper>
  );
}

const Wrapper = styled.div<{
  aspectRatio?: AspectRatio;
  timelineHeight: number;
  currentWidth: number;
}>`
  width: 80%;
  display: flex;
  align-items: center;
  z-index: 1;

  ${({ aspectRatio, timelineHeight }) =>
    (!aspectRatio || aspectRatio === AspectRatio.AR_16_9) &&
    css`
      margin: 0 auto ${timelineHeight > 60 ? '50px' : '80px'} auto;
    `}
  ${({ aspectRatio }) =>
    (aspectRatio === AspectRatio.AR_1_1 ||
      aspectRatio === AspectRatio.AR_9_16) &&
    css`
      margin: 0 auto 30px auto;
    `}

  ${forIPad(`
    width: 95%;
  `)}

  ${({ currentWidth }) =>
    currentWidth < 400 &&
    css`
      flex-wrap: wrap;

      .bottom-items-left {
        order: 2;
      }
      .bottom-items-mid {
        order: 1;
        flex-basis: 100%;
        margin-bottom: 8px;
      }
      .bottom-items-right {
        order: 3;
      }
    `}
`;

const BottomItemsLeft = styled.div.attrs({ className: 'bottom-items-left' })`
  display: flex;
  justify-content: flex-start;
  flex: 1;
  gap: 2px;
`;

const BottomItemsMid = styled.div.attrs({ className: 'bottom-items-mid' })`
  display: flex;
  justify-content: center;
  // flex-direction: column;
  gap: 16px;
  align-items: center;
  flex: 1;
  position: relative;

  ${forIPad(`
    gap: 8px;
  `)}
`;

const BottomItemsRight = styled.div.attrs({ className: 'bottom-items-right' })`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  gap: 8px;
`;

export { BottomItems, BottomItemsLeft, BottomItemsMid, BottomItemsRight };
